import useAppSelector from 'hooks/shared/store/useAppSelector';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { Navigate, useLocation } from 'react-router-dom';
import AppRoute from 'router/AppRoute';
import { getLoginReturnPath } from 'router/getLoginReturnPath';
import { authSelector } from 'selectors/modules/auth';
import { AuthStatus } from 'slices/modules/auth/authState';

import LoginContainer from 'presentation/containers/modules/login/LoginContainer';
import Header from 'presentation/layout/shared/Header/Header';
import { FC } from 'react';

const LoginPage: FC = () => {
  const { status } = useAppSelector(authSelector);
  const location = useLocation();

  const { t } = useTranslation();

  if (status === AuthStatus.LoggedIn) {
    return (
      <Navigate to={getLoginReturnPath(location.state, AppRoute.portfolio)} replace />
    );
  }

  return (
    <>
      <Helmet>
        <title>{t('loginHeadTitle')}</title>
      </Helmet>
      <Header showDivider />
      <LoginContainer />
    </>
  );
};

export default LoginPage;
